var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],style:(_vm.getStartTimeColor())},[_vm._v(_vm._s(_vm.prepend)+" "+_vm._s(_vm.toStart)+" "+_vm._s(_vm.append)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }